import { Record } from 'immutable';
export default class Permission extends Record({
  roleId: undefined,
  roleName: undefined
}) {}